"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EngageEndpointHandler = void 0;
const rxjs_1 = require("rxjs");
const ChannelInstructionType_1 = require("../channelInstruction/ChannelInstructionType");
const IdentifyCustomer_1 = require("../identifyCustomer/IdentifyCustomer");
const MessageType_1 = require("../message/MessageType");
const Notify_1 = require("../notify/Notify");
const Redirect_1 = require("../redirect/Redirect");
const IResult_1 = require("../shared/IResult");
const URLContent_1 = require("../urlContent/URLContent");
class EngageEndpointHandler {
    constructor(router, endpointEngagedHandler, messageClient, identityCustomerProvider) {
        this.router = router;
        this.endpointEngagedHandler = endpointEngagedHandler;
        this.messageClient = messageClient;
        this.identityCustomerProvider = identityCustomerProvider;
        this.notifyObservable = new rxjs_1.Subject();
        this.redirectObservable = new rxjs_1.Subject();
        this.identifyCustomerObservable = new rxjs_1.Subject();
        this.router.setHandler(MessageType_1.MessageType.EngageEndpointRequest, this);
    }
    handle(message) {
        if (this.isEngageEndpointRequest(message)) {
            if (this.isNotify(message)) {
                const result = {
                    action: IResult_1.Action.APPROVED,
                };
                this.sendEngageEndpointResponse(message, result);
                const notify = new Notify_1.Notify(message, this.endpointEngagedHandler);
                this.notifyObservable.next(notify);
            }
            else if (this.isRedirect(message)) {
                const result = {
                    action: IResult_1.Action.APPROVED,
                };
                this.sendEngageEndpointResponse(message, result);
                const redirect = new Redirect_1.Redirect(message, this.endpointEngagedHandler);
                this.redirectObservable.next(redirect);
            }
            else if (this.isIdentifyCustomer(message)) {
                const result = {
                    action: IResult_1.Action.APPROVED,
                };
                this.sendEngageEndpointResponse(message, result);
                const identifyCustomer = new IdentifyCustomer_1.IdentifyCustomer(message, this.endpointEngagedHandler, this.identityCustomerProvider);
                this.identifyCustomerObservable.next(identifyCustomer);
            }
            else if (this.isURLContent(message)) {
                const result = {
                    action: IResult_1.Action.APPROVED,
                };
                this.sendEngageEndpointResponse(message, result);
                new URLContent_1.URLContent(message, this.endpointEngagedHandler);
            }
        }
    }
    onNotify() {
        return this.notifyObservable;
    }
    onRedirect() {
        return this.redirectObservable;
    }
    onIdentifyCustomer() {
        return this.identifyCustomerObservable;
    }
    sendEngageEndpointResponse(request, result) {
        const response = {
            messageName: MessageType_1.MessageType.EngageEndpointResponse,
            payload: {
                messageID: request.payload.messageID,
                interaction: {
                    entersektInteractionID: request.payload.interaction.entersektInteractionID,
                    type: request.payload.interaction.type,
                },
                result,
            },
        };
        return this.messageClient.send(response);
    }
    isNotify(request) {
        const type = request.payload.channelInstruction.type;
        if (type === ChannelInstructionType_1.ChannelInstructionType.NOTIFY_CHECK ||
            type === ChannelInstructionType_1.ChannelInstructionType.NOTIFY_CHECK_PAUSE ||
            type === ChannelInstructionType_1.ChannelInstructionType.NOTIFY_IN_PROGRESS ||
            type === ChannelInstructionType_1.ChannelInstructionType.NOTIFY_RESULT ||
            type === ChannelInstructionType_1.ChannelInstructionType.NOTIFY_RESULT_PAUSE) {
            return true;
        }
        else
            return false;
    }
    isIdentifyCustomer(request) {
        const type = request.payload.channelInstruction.type;
        if (type === ChannelInstructionType_1.ChannelInstructionType.SCAN_CUSTOMER_ID) {
            return true;
        }
        else
            return false;
    }
    isRedirect(request) {
        const type = request.payload.channelInstruction.type;
        if (type === ChannelInstructionType_1.ChannelInstructionType.REDIRECT || type === ChannelInstructionType_1.ChannelInstructionType.REDIRECT_PAUSE) {
            return true;
        }
        else
            return false;
    }
    isURLContent(request) {
        const type = request.payload.channelInstruction.type;
        if (type === ChannelInstructionType_1.ChannelInstructionType.GET_URL_CONTENT || type === ChannelInstructionType_1.ChannelInstructionType.POST_URL_CONTENT) {
            return true;
        }
        else
            return false;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    isEngageEndpointRequest(object) {
        return (object.payload instanceof Object &&
            "payload" in object &&
            "channelInstruction" in object.payload &&
            "messageID" in object.payload &&
            "interaction" in object.payload);
    }
}
exports.EngageEndpointHandler = EngageEndpointHandler;
//# sourceMappingURL=EngageEndpointHandler.js.map